import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconBlogPapers = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <path
            d="M8.81055 15.8125H5.31055C5.07848 15.8125 4.85592 15.7203 4.69183 15.5562C4.52773 15.3921 4.43555 15.1696 4.43555 14.9375V5.3125C4.43555 5.08044 4.52773 4.85788 4.69183 4.69378C4.85592 4.52969 5.07848 4.4375 5.31055 4.4375H14.0605C14.2926 4.4375 14.5152 4.52969 14.6793 4.69378C14.8434 4.85788 14.9355 5.08044 14.9355 5.3125V9.25M8.81055 7.0625H12.3105M7.06055 9.6875H12.3105M7.06055 12.3125H11.4355"
            stroke="black"
            strokeWidth="0.875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9916 16.8585L10.125 17.125L10.3915 15.2564L15.1918 10.4561C15.297 10.351 15.4219 10.2677 15.5592 10.2109C15.6966 10.1541 15.8439 10.1249 15.9926 10.125C16.1412 10.1251 16.2884 10.1545 16.4258 10.2115C16.5631 10.2684 16.6878 10.3519 16.7929 10.4571C16.898 10.5623 16.9813 10.6872 17.0381 10.8246C17.0949 10.9619 17.1241 11.1092 17.124 11.2579C17.1239 11.4065 17.0945 11.5537 17.0375 11.6911C16.9806 11.8284 16.8971 11.9531 16.7919 12.0582L11.9916 16.8585Z"
            fill="#FFB700"
            stroke="#1E1E1E"
            strokeWidth="0.754287"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="14"
              height="14"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
